import { createAction } from '@reduxjs/toolkit';

export const initState = createAction('root/initState');

export const resetState = createAction('root/resetState');
